<template>
    <div>
        <v-container fluid pa-0 ma-0 style="border:1px; background-color:lightgrey">
            <!-- Kopfzeile -->
            <v-layout pt-2 pb-2 justify-space-between>
                <v-flex ml-1 xs2 class="title">
                    DemoBot
                </v-flex>
                <v-flex mr-1 xs2 text-xs-right>
                    <v-icon style="font-size:18px">
                        fa-times
                    </v-icon>
                </v-flex>
            </v-layout>
        </v-container>
        <!----------------------------------------------------
             BOT: The second row with the chats of the bot
        ----------------------------------------------------->
        <v-container mt-1 pa-1 fluid class="msg_container_base gelb" id=chatContainer>

            <!-- Each Chat entry is a row ; traverse in teh for loop-->
            <v-layout v-for="message of messageList" :key="message.timestamp" justify-space-between>

                <!-- Sending -->
                <v-flex xs-7 md-6 v-if="message.author=='me'">


                    <div class="msg_sent" >
                        {{ message.data.text}}
                    </div>

                    <div class="mytime">
                        Sie, {{fuzzyTime( message.timestamp )}}

                    </div>


                </v-flex>

                <!-- Wichtig, weil immer das 2te v-flex element -->
                <v-flex xs-1>
                    &nbsp;
                </v-flex>

                <!-- Receiving -->
                <v-flex xs-7 md-6 ma-0 v-if="message.author!='me'">

                    <!-- Benutze flexbox um den Text nach rechts zu bringen-->
                    <div style="display:flex; justify-content:flex-end">
                        <div class="msg_received">
                            {{ message.data.text}}
                        </div>
                    </div>

                    <div class="bottime">
                        {{ message.author}}, {{ fuzzyTime( message.timestamp) }}
                    </div>

                </v-flex>

            </v-layout> <!-- Chat Display Area -->
        </v-container>

        <v-container fluid pa-0 mt-1>
            <v-layout row wrap>

                <!-- The microphone symbol -->
                <v-flex xs1  text-xs-center style="border-right:2px solid white; margin-bottom:26px; background-color:#e5e5e5">

                    <div style="margin-top:18px">
                        <span v-if="isRecording"
                              v-on:click="uiEvent('doToggleRecordMode')">

                            <v-icon color="red" small>
                                fa-microphone
                            </v-icon>

                        </span>

                        <span v-if="!isRecording"
                              v-on:click="uiEvent('doToggleRecordMode')">

                            <v-icon color="lightgrey" small>
                                fa-microphone-slash
                            </v-icon>

                        </span>

                    </div>

                </v-flex>


                <v-flex xs10 background-color="primary">

                    <v-text-field 
                                  v-model="messageText"
                                  placeholder="Write..."
                                  v-on:keyup.enter="submit"
                                  box
                                  label="Type your Message"
                                 
                                  >

                    </v-text-field>

                </v-flex>


                <v-flex xs1  text-xs-center style="border-left:2px solid white; margin-bottom:26px; background-color:#e5e5e5">
                    
                        <v-icon style="margin-top:18px;"
                                v-on:click="submit"
                                small
                                >

                            fa-share

                        </v-icon>
                    
                </v-flex>

            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import { Utils } from './../classes/Utils.js';

    export default {
        props: ['messageList'],


        data() {
            return {
                isRecording: false,
                isSpeechAvailable: true,

                uiState: "State",
                uiMessage: "Message",

                messageText: "",

                tu: Utils,

            };
        },

        computed: {
            userName() {
                console.log("Store call back");
                return this.$store.state.currentUser;
            }
        },

        methods: {


            submit() {
                this.uiEvent('send-message');
            },

            uiEvent(event) {
                console.log("uiEvent : " + event);
                // Process events, that do not need store call
                switch (event) {
                    case "send-message":
                        this.$emit('send-message', this.messageText);
                        this.messageText = "";
                        return;

                    case "doToggleRecordMode":
                        //this.isRecording = !this.isRecording;
                        this.$store.commit("setSnackbarText", "Die Spracherkennung des Bots ist noch nicht implementiert.");
                        return;


                }

            },

            fuzzyTime(ti) {
                console.log("TIme :" + ti);
                let delta = Math.round(( Date.now() - ti) / 1000);

                let minute = 60,
                    hour = minute * 60,
                    day = hour * 24;
                 // currently unused   week = day * 7;

                let fuzzy = delta;

                if (delta < 30) {
                    fuzzy = 'gerade eben.';
                } else if (delta < 2 * minute) {
                    fuzzy = 'vor einer Minute.'
                } else if (delta < hour) {
                    fuzzy = "vor " + Math.floor(delta / minute) + ' Minuten.';
                } else if (Math.floor(delta / hour) == 1) {
                    fuzzy = 'vor etwa einer Stunde'
                } else if (delta < day) {
                    fuzzy = "vor" + Math.floor(delta / hour) + 'Stunden.';
                } else if (delta < day * 2) {
                    fuzzy = 'gestern';
                }

                return fuzzy;
            },
        },

        watch: {
            /* Brauchen wir nicht, ist aber gut zu wissen...
            messageList: function (newVal, oldVal) {

                console.log("Prop changed : " + newVal.length);

            }
            */
        },

        updated: function () {
            this.$nextTick(function () {
                console.log("UPDATED");
                document.getElementById("chatContainer").scrollTop = 10000;
            })
        },

    };
</script>

<style scoped>

    /* The overall container of the bot ---------------------- */
    .msg_container_base {
        background: #e5e5e5;
        height: 350px;
        overflow-x: auto;
    }

        .msg_container_base::-webkit-scrollbar-track {
            -webkit-box-shadow: rgba(0,0,0,0.3);
            background-color: #F5F5F5;
        }

        .msg_container_base::-webkit-scrollbar {
            width: 5px;
            background-color: #F5F5F5;
        }

        .msg_container_base::-webkit-scrollbar-thumb {
            -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
            background-color: #555;
        }


    /* Styles for received and sent messages -------------- */

    .msg_sent {
        background: white;
        max-width: 60%;
        align-content: flex-start;
        padding-left: 5px; /* Inneneinzup vn links*/
        margin-top: 10px !important;
        margin-left: 2px !important;
        padding-bottom: 0px !important;
        padding-left: 5px !important;
        border-radius: 2px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
        margin: 0 0 0.2rem 0; /*-- 3. Parameter ist der Abstand nach unten */
    }

    .msg_received {
        background: lightblue;
        text-align: right;
        padding-right: 0px; /* Inneneinzup von rechts*/
        margin-top: 10px !important;
        margin-right: 5px !important;
        margin-bottom: 0.2rem !important;
        padding-bottom: 0px !important;
        padding: 0px;
        border-radius: 2px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
        max-width: 60%;
    }


    .bottime {
        font-size: 9px;
        color: darkslategray;
        text-align: right;
        margin-right: 2px !important;
    }

    .mytime {
        font-size: 9px;
        color: darkslategray;
        text-align: left;
        margin-right: 2px !important;
    }
</style>

